export type NavMode = "expanded" | "rail";

const KEY = "helm.nav";
const MODES: readonly NavMode[] = ["expanded", "rail"];

type Store = Pick<Storage, "getItem" | "setItem">;

function store(): Store | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function readNavMode(s: Store | null = store()): NavMode {
  try {
    const v = s?.getItem(KEY);
    // The sidebar can no longer be hidden; whoever hid it gets the rail.
    if (v === "hidden") return "rail";
    return MODES.find((m) => m === v) ?? "expanded";
  } catch {
    return "expanded";
  }
}

export function writeNavMode(mode: NavMode, s: Store | null = store()): void {
  try {
    s?.setItem(KEY, mode);
  } catch {
    // Private windows and blocked storage just don't remember the choice.
  }
}
